<sirius-container>
    @if (resolvedTitle()) {
        <sirius-heading
            [id]="titleId"
            [text]="resolvedTitle()"
            textStyleCategory="title"
            textStyleSize="m"
        ></sirius-heading>
    }
    <sirius-card-grid [items]="resolvedItems()" cardSize="medium"></sirius-card-grid>
</sirius-container>
